import { observable, runInAction } from 'mobx';

export class MessageStore {
    @observable public messages: any = observable([]);

    public addMessage(text: string, type: string, timeout?: number) {
        const messages = this.messages.slice();

        messages.push({
            key: this.guid(),
            'text': text,
            timeout,
            'type': type,
        });

        this.messages = messages;
    }

    public removeMessage(message: any) {
        const messages = this.messages.slice();
        const newMessages = messages.filter(
            (item: any) => item.key !== message.key
        );
        runInAction(() => {
            this.messages = newMessages;
        });
    }

    public removeAllMessages() {
        this.messages = [];
    }

    
    private guid() {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }
        return (s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()).replace(/-/g, '');
      }
}

export default new MessageStore();


// WEBPACK FOOTER //
// ./src/Stores/Messages/Messages.tsx